export const API_URL: string = (() => {
  return process.env.NEXT_PUBLIC_API_URL
})() as string
